import { formatDate } from '../../utils';

const transformOrganizationWithCountData = ({ results = [], count }) => ({
  results: results.map(({ id, name, displayName, description, status, createdAt }) => ({
    id,
    name,
    displayName,
    description,
    status,
    createdOn: formatDate(createdAt),
  })),
  count,
});

export default transformOrganizationWithCountData;
